var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDarkModeLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#C8C8C9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.98 14.316a6.055 6.055 0 0 1-1.982 2.463 6.359 6.359 0 0 1-2.993 1.175 6.436 6.436 0 0 1-3.2-.43 6.209 6.209 0 0 1-2.547-1.918 5.908 5.908 0 0 1-1.211-2.892 5.834 5.834 0 0 1 .45-3.09 6.057 6.057 0 0 1 1.99-2.456 6.36 6.36 0 0 1 2.996-1.166.375.375 0 0 1 .219.041.357.357 0 0 1 .188.367.341.341 0 0 1-.1.19c-.447.428-.8.938-1.04 1.5a4.409 4.409 0 0 0-.352 1.77 4.5 4.5 0 0 0 .64 2.274 4.705 4.705 0 0 0 1.716 1.673 4.911 4.911 0 0 0 2.348.638 4.921 4.921 0 0 0 2.368-.56.39.39 0 0 1 .422.048.354.354 0 0 1 .087.373z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDarkModeLight);
export default __webpack_public_path__ + "static/media/icon-dark-mode-light.62e65badc36762051a562ed2bbf4c664.svg";
export { ForwardRef as ReactComponent };